import { Button, Menu, MenuItem } from "@material-ui/core";
import { GetApp as ExportIcon } from "@material-ui/icons";
import {
	ExportServerPDFButton,
	ExportServerXLSXButton,
} from "components/dialogs/ExportDialog/ExportServerButton";
import React from "react";
import { useTranslate } from "react-admin";

export const DownloadPalletsExportDropdown = ({ filters, filenamePrefix }) => {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const translate = useTranslate();

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<div>
			<Button
				variant="contained"
				color="primary"
				size="small"
				onClick={handleClick}
				startIcon={<ExportIcon />}
			>
				{translate("osfc.buttons.print")}
			</Button>
			<Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
				<MenuItem onClick={handleClose}>
					<ExportServerXLSXButton endpoint="pallets" filters={filters} filename={filenamePrefix} />
				</MenuItem>
				<MenuItem onClick={handleClose}>
					<ExportServerPDFButton endpoint="pallets" filters={filters} filename={filenamePrefix} />
				</MenuItem>
			</Menu>
		</div>
	);
};
